var _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _ellipse2, _path9, _ellipse3, _ellipse4, _ellipse5, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWellLit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208.447,
    cy: 111.552,
    r: 16.085,
    fill: "#FFBD3E",
    stroke: "#FFBD3E",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 208.815,
    y1: 71,
    x2: 208.815,
    y2: 87.9834,
    stroke: "#FFBD3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.24 5.24"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 225.818,
    y1: 93.6527,
    x2: 237.89,
    y2: 81.5801,
    stroke: "#FFBD3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.24 5.24"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 226.905,
    y1: 129.25,
    x2: 238.977,
    y2: 141.323,
    stroke: "#FFBD3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.24 5.24"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 178.134,
    y1: 140.996,
    x2: 190.207,
    y2: 128.923,
    stroke: "#FFBD3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.24 5.24"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 179.549,
    y1: 81.5802,
    x2: 191.621,
    y2: 93.6528,
    stroke: "#FFBD3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.24 5.24"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 208.815,
    y1: 135.122,
    x2: 208.815,
    y2: 152.105,
    stroke: "#FFBD3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.24 5.24"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 167.895,
    y1: 111.185,
    x2: 184.878,
    y2: 111.185,
    stroke: "#FFBD3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.24 5.24"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 232.017,
    y1: 111.185,
    x2: 249,
    y2: 111.185,
    stroke: "#FFBD3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.24 5.24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.4201 147.149C89.6977 143.364 96.2454 142.456 102.906 143.671C112.959 145.504 118.853 155.441 120.234 165.565L123.233 187.561C123.383 188.658 122.53 189.635 121.424 189.635H108.634",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3334 160.411C91.8923 156.75 96.6928 156.766 105.251 160.411",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.516 160.411C132.075 156.75 136.875 156.766 145.434 160.411",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.041 158.689C136.406 158.548 138.381 158.827 141.625 159.691L141.653 159.468C141.737 159.814 141.781 160.174 141.781 160.545C141.781 163.067 139.736 165.111 137.215 165.111C134.693 165.111 132.648 163.067 132.648 160.545C132.648 159.884 132.789 159.256 133.041 158.689Z",
    fill: "#424243"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.795 203.199C114.807 205.843 119.629 205.417 127.626 203.199",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6985 177.306C68.4401 205.36 76.6008 212.215 102.087 223.908C110.201 227.631 119.827 226.624 126.784 221.03C142.187 208.644 148.873 198.771 151.37 168.63C155.023 124.525 141.781 104.246 104.565 101.986C67.3493 99.7264 58.6457 125.453 58.3676 155.845",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3288 158.128C76.0274 154.475 84.7032 147.169 97.032 131.644C112.557 143.059 128.995 148.082 146.804 151.735L153.266 152.496C153.933 152.574 154.498 151.999 154.423 151.333C150.106 113.021 134.577 97.3716 103.425 95.1142C69.1782 100.137 56.8494 120.685 56.8494 155.845C59.6783 155.306 60.5023 155.845 62.3288 158.128Z",
    fill: "#424243",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.1005,
    cy: 128.121,
    rx: 10.0097,
    ry: 13.7751,
    transform: "rotate(-35 66.1005 128.121)",
    fill: "#424243"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8723 157.566C60.4725 155.733 57.6803 155.225 55.3979 156.724C54.6695 157.202 54.211 157.982 53.9484 158.813C50.9837 168.194 53.9931 179.294 57.3837 181.617C60.3281 183.633 62.955 181.575 64.1554 180.959",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.6164,
    cy: 96.0272,
    rx: 19.1781,
    ry: 13.242,
    transform: "rotate(-15 85.6164 96.0272)",
    fill: "#424243"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.539 96.0461C86.045 96.2931 85.8448 96.8938 86.0918 97.3877C86.3388 97.8817 86.9394 98.0819 87.4334 97.8349L86.539 96.0461ZM107.589 94.4716L108.589 94.4746L108.595 92.4747L107.595 92.4716L107.589 94.4716ZM87.4334 97.8349C91.7884 95.6575 99.5952 94.4475 107.589 94.4716L107.595 92.4716C99.5022 92.4472 91.3165 93.6573 86.539 96.0461L87.4334 97.8349Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.0503,
    cy: 174.566,
    rx: 8.21918,
    ry: 5.02283,
    fill: "#FFBD3E"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.804,
    cy: 174.566,
    rx: 8.21918,
    ry: 5.02283,
    fill: "#FFBD3E"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.2702,
    cy: 109.52,
    rx: 13.8327,
    ry: 12.3622,
    transform: "rotate(-51.7823 68.2702 109.52)",
    fill: "#424243"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.954 158.489C92.6417 159.107 92.4658 159.805 92.4658 160.545C92.4658 163.067 94.5102 165.111 97.032 165.111C99.5539 165.111 101.598 163.067 101.598 160.545C101.598 160.213 101.563 159.89 101.496 159.579C98.3319 158.687 96.3609 158.394 92.954 158.489Z",
    fill: "#424243"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWellLit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/well_lit.69d195477e21c2e0e83e74aa9d2e2a62.svg";